// extracted by mini-css-extract-plugin
export default {"infoPopup":"uEatO","infoPopup-body":"ZPo7X","infoPopup-link":"Qtktt"};